export default "__VITE_ASSET__ZStke8M$__"